import { annotationData } from 'src/app/test_data/mapLayout';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { ZoomComponent } from '../zoom/zoom.component';
import { HttpClient } from '@angular/common/http';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-annotation-right',
  templateUrl: './edit-annotation-right.component.html',
  styleUrls: ['./edit-annotation-right.component.css'],
})
export class EditAnnotationRightComponent implements OnInit, OnDestroy {
  annotationForm!: FormGroup;
  annotationData: any;
  createAnn: any;
  state: any;
  json: any;
  userFields: any
  type: any;
  save = '<span>Save</span>';
  // closeRight =
  //   '<span><strong>Close</strong><p>Clear map selection(s) and close panel</p></span>';
  myClose = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class15',
  };
  myOptions12 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class12',
  };
  htmlText ="<p>Testing</p>"
  editorStyle = {
    display: 'inline-block',
    width: '100%'
  };
  hasFocus = false;
  hideDeleteBin = false
  subject?: string;

  quillConfig={
    toolbar: {
      container: [
        // toggled buttons
        ['bold', 'italic', 'underline', 'strike'],
        ['code-block'],
        // custom button values
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        // remove formatting button
        ['clean'],
        ['link'],
      ],

    },
  }
  constructor(
    public sideNavService: SideNavService,
    public mapService: MapServiceService,
    private http: HttpClient,
    private fb: FormBuilder,
  ) {
    //
  }

  ngOnInit(): void {
    this.sideNavService.clickedInfo(0);
    if (this.sideNavService.annotationType == 'create') {
      this.annotationData = this.sideNavService.dataPassToRightPanel;
      this.createAnn = true;
    } else {
      this.annotationData = this.sideNavService.dataPassToRightPanel;
    }
    this.annotationForm = this.fb.group({
      user_fields: this.fb.array([]),
    });
    if(this.annotationData.attributeData != undefined) {
      this.populateForm(this.annotationData.attributeData);
        if(this.annotationData.attributeData.length > 0) {
      this.hideDeleteBin = true
      }
    }



  }
  populateForm(existingData: any[]): void {
    const userFields = this.annotationForm.get('user_fields') as FormArray;

    // Clear existing form controls
    while (userFields.length) {
      userFields.removeAt(0);
    }

    // Add form controls for each existing data item
    existingData.forEach(item => {
      userFields.push(this.fb.group({
        fieldname: item.fieldname,
        fieldname2: item.fieldname2
      }));
    });
    this.userFields = JSON.stringify(existingData)
  }

  mapInfo(): FormArray {
    return this.annotationForm.get('user_fields') as FormArray;
  }
  newMapdata(): FormGroup {
    return this.fb.group({
      fieldname: '',
      fieldname2: '',
    });
  }
  addMaps(): void {
    this.mapInfo().push(this.newMapdata());
  }
  removeMapInfo(empIndex: number) {
    this.mapInfo().removeAt(empIndex);
    this.userFields = JSON.stringify(this.mapInfo().value.map((obj: any) => {
      return {
        fieldname: obj.fieldname,
        fieldname2: obj.fieldname2
      };
    }));
  }
  onContentChanged = (event: any) =>{
    console.log(event.html);
    this.userFields = JSON.stringify(this.mapInfo().value.map((obj: any) => {
      return {
        fieldname: obj.fieldname,
        fieldname2: obj.fieldname2
      };
    }));


  }
  closeRightpanel(): void {
    //after create annotation now destroy features on close
    // if (this.sideNavService.newAnnoCreated) {
    this.sideNavService.activeFeatureList = [];
    if (this.mapService.result) {
      this.mapService.result.getSource().clear();
      this.sideNavService.saveFeatureListData = [];
    }
    this.sideNavService.newAnnoCreated = false;
    // }
    this.mapService.stopHover = true;
    this.sideNavService.closeRightSideNav();
    if (this.sideNavService.DrawlayerAnnot) {
      this.sideNavService.DrawlayerAnnot.getSource().clear();
    }
    // this.sideNavService.sideNavState('close');
    // this.sideNavService.infoSideNav('closed');
  }
  ngOnDestroy() {
    this.mapService.stopHover = true;
  }
  capitalizeFirstLetter(string: any) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  create(): void {
    this.annotationData.user_fields = this.userFields

    if (this.createAnn == true) {
      this.mapService
        .createAnnotation(this.annotationData)
        .subscribe((res: any) => {
          this.createAnn = false;

          this.sideNavService.refreshAnnotationComponent(res.annotation);
          this.sideNavService.closeRightSideNav();
          //hover deactivate
          this.mapService.stopHover = false;
          this.type = res.annotation.type;
          this.state = `${'Annotation:'}${this.capitalizeFirstLetter(
            this.type
          )}:${'Save'}`;
          this.json = {
            annotation_label: `${this.annotationData.name}`,
            annotation_description: `${this.annotationData.description}`,
          };
          this.json = JSON.stringify(this.json);
          this.activityLoging(this.state);

          this.sideNavService.rightMenuClicked({
            component: ZoomComponent,
            data: res.annotation,
            history: false,
            push: true,
          });
        });
    }
  }

  edit(): void {
    delete this.annotationData.attributeData;
    this.annotationData.user_fields = this.userFields
    if (this.sideNavService.annotationType == 'editFolder') {
      const folderId = this.annotationData.folderId;
      const saveID = folderId;

      delete this.annotationData.folderId;

      this.mapService
        .editAnnotation(this.annotationData)
        .subscribe((res: any) => {
          res.type = 'editFolder';
          res.folderId = saveID;

          this.sideNavService.editAnnotationAfter(res);
          // this.sideNavService.closeRightSideNav();
          //hover deactivate
          this.mapService.stopHover = false;
          res.annotations.subType = 'folder';
          res.annotations.folderId = saveID;
          this.type = res.annotations.type;
          this.sideNavService.rightMenuClicked({
            component: ZoomComponent,
            data: res.annotations,
            history: false,
            push: true,
          });

          this.state = `${'Annotation:'}${this.type}:${'Save'}`;
          this.json = {
            annotation_label: `${this.annotationData.name}`,
            annotation_description: `${this.annotationData.description}`,
          };
          this.json = JSON.stringify(this.json);
          this.activityLoging(this.state);
          this.sideNavService.sideNavState('open');
          this.sideNavService.infoSideNav('closed');
        });
    } else {
      this.mapService
        .editAnnotation(this.annotationData)
        .subscribe((res: any) => {
          this.sideNavService.editAnnotationAfter(res);
          // this.sideNavService.closeRightSideNav();
          //hover deactivate
          this.mapService.stopHover = false;
          this.type = res.annotations.type;
          this.sideNavService.rightMenuClicked({
            component: ZoomComponent,
            data: res.annotations,
            history: false,
            push: true,
          });

          this.state = `${'Annotation:'}${this.type}:${'Save'}`;
          this.json = {
            annotation_label: `${this.annotationData.name}`,
            annotation_description: `${this.annotationData.description}`,
          };
          this.json = JSON.stringify(this.json);
          this.activityLoging(this.state);
          this.sideNavService.sideNavState('open');
          this.sideNavService.infoSideNav('closed');
        });
    }
  }

  activityLoging(state: any) {
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapService.mapId.toString(),
          event: 'Click',
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: state,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          event_information: this.json,
          point: '',
          wkt: '',
        };
        this.mapService.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }
}
